// @flow
import * as React from 'react'
import {compose} from 'redux'
import css from '$common/components/TextInput/index.css'
import {resolveCss, withTranslate, type WithTranslateProps} from '$util'

type Props = WithTranslateProps & {
  input: {
    value: mixed,
    onChange: Function
  },
  meta: {
    active: boolean
  },
  css?: any,
  label: string,
  placeholder: ?string,
  'data-tid'?: string,
}

type State = {
  showing: boolean
}

class PasswordInput extends React.Component<Props, *> {
  props: Props
  state: State

  constructor(props: Props) {
    super(props)
    this.state = {showing: false}
  }

  toggleShowingState() {
    this.setState(({showing}) => ({showing: !showing}))
  }

  render() {
    const {props} = this
    const {showing} = this.state
    const classes = resolveCss(css, props.css)

    return (
      <div {...classes('container', props.meta.active && 'inFocus')}>
        <div {...classes('topRow')}>
          <div {...classes('label')}>{props.label}</div>
          <a
            {...classes('showOrHide', showing && 'showing')}
            onClick={() => this.toggleShowingState()}
          >
            {showing
              ? this.props.t('common.hide')
              : this.props.t('common.show')}
          </a>
        </div>
        <input
          {...classes('input')}
          type={showing ? 'text' : 'password'}
          {...props.input}
          placeholder={props.placeholder}
          data-tid={props['data-tid']}
        />
      </div>
    )
  }
}

export default compose(withTranslate())(PasswordInput)



// WEBPACK FOOTER //
// ./src/common/components/PasswordInput/index.js